module.exports = __webpack_public_path__ + "static/img/14areaA_2.7f949d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/14areaA_2.png
// module id = 795
// module chunks = 1